export class QueryGroup {
	public TypeName = "QueryGroup";
	public Parts: Array<any>;

	constructor() {
		this.Parts = new Array<any>();
	}
}